import React from 'react';

type HelpTipProps = {
  text: string;
  href?: string;
  hrefLabel?: string;
  label?: string;
};

const HelpTip: React.FC<HelpTipProps> = ({ text, href, hrefLabel, label }) => {
  const tooltipId = React.useId();
  return (
    <span className="dod-help-tip">
      <button
        type="button"
        className="dod-help-tip-btn"
        aria-label={label || 'More information'}
        aria-describedby={tooltipId}
        onClick={(event) => event.stopPropagation()}
      >
        ?
      </button>
      <span className="dod-help-tip-pop" id={tooltipId} role="tooltip">
        {text}
        {href ? (
          <>
            {' '}
            <a href={href} target="_blank" rel="noopener noreferrer">
              {hrefLabel || href}
            </a>
          </>
        ) : null}
      </span>
    </span>
  );
};

export default HelpTip;
